/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const RoamTransactionListService = {
  /**
   * Get Screen data
   *
   * */
  async getReportPreviewScreenName(screenName) {
    const requestScreenData = {
      url: "api/TransactionListReportPreview",
      // top: "1",
      filter: `ScreenName eq '${screenName}' and Status eq 'A'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getReportBackgroundScreenName(screenName, params) {
    const requestScreenData = {
      url: "api/TransactionListReportBackground",
      filter: `ScreenName eq '${screenName}' and Status eq 'A'`,
    };

    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async reportBackgroundPrintOrder(payload) {
    var url = "api/Save_ReportBackgroundPrint";
    await ApiService.post(url, payload);
  },

  async getReportPreviewScreens() {
    const requestScreenData = {
      url: "api/TransactionListReportPreview",
      filter: `Status eq 'A'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getReportBackgroundScreens() {
    const requestScreenData = {
      url: "api/TransactionListReportBackground",
      filter: `Status eq 'A'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { RoamTransactionListService };
